<template>
    <svg version="1.1" id="exam-next-icon" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" viewBox="0 0 191.1 337" style="enable-background:new 0 0 191.1 337;" xml:space="preserve">
<path d="M0,314.3V22.7C0,2.5,24.4-7.6,38.7,6.7l145.8,145.8c8.8,8.8,8.8,23.2,0,32L38.7,330.3C24.4,344.6,0,334.5,0,314.3z"/>
</svg>
</template>

<script>
    export default {
        name: "NextIcon"
    }
</script>

<style scoped>

</style>
